import { render } from "./APKManagement.vue?vue&type=template&id=fc78843c&scoped=true"
import script from "./APKManagement.vue?vue&type=script&lang=js"
export * from "./APKManagement.vue?vue&type=script&lang=js"

import "./APKManagement.vue?vue&type=style&index=0&id=fc78843c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc78843c"]])

export default __exports__